import { motion } from 'motion/react';
import React, { useEffect, useRef } from 'react';
const ParallaxBlockItem = ({ children, index, setIndex, scrollPosition }) => {
    const ref = useRef(null);
    useEffect(() => {
        const { top } = ref.current?.getBoundingClientRect() || {
            top: 0
        };
        const { innerHeight } = window;
        if (top < innerHeight / 2) {
            setIndex(index);
        }
    }, [scrollPosition]);
    return (React.createElement(motion.div, { whileInView: { opacity: 1 }, initial: { opacity: 0 }, transition: { duration: 0.6, delay: 0.2 }, viewport: { once: true }, ref: ref }, children));
};
export default ParallaxBlockItem;
